fun rankArray(arr: List<Rect>):List<Int>{
    val ranks = mutableListOf<Int>()
    arr.forEach { me ->
        var rank = arr.size
        arr.forEach{ other ->
            if(me.height < other.height){
                rank--
            }
        }
        ranks.add(rank)
    }
    return ranks
}